import {prop} from 'ramda';

import {PositionedDashboardGridTile} from './allocateDashboardGrid';
import {DASHBOARD_TILE_SIZES} from './dashboardTileSizes';

export interface DashboardStructuralBand {
  startRow: number;
  endRow: number;
}

const getTileBottom = (tile: PositionedDashboardGridTile) =>
  tile.row + prop(tile.size, DASHBOARD_TILE_SIZES).rows;

const isLegalBoundary = (tiles: PositionedDashboardGridTile[], row: number) =>
  !tiles.some((tile) => tile.row < row && getTileBottom(tile) > row);

export function getDashboardStructuralBand(
  tiles: PositionedDashboardGridTile[],
  tileId: PositionedDashboardGridTile['id']
): DashboardStructuralBand | null {
  const tile = tiles.find((candidate) => candidate.id === tileId);

  if (tile === undefined) {
    return null;
  }

  const tileBottom = getTileBottom(tile);
  let startRow = tile.row;
  let endRow = tileBottom;

  while (startRow > 0 && !isLegalBoundary(tiles, startRow)) {
    startRow -= 1;
  }

  const boardBottom = tiles.reduce(
    (bottom, candidate) => Math.max(bottom, getTileBottom(candidate)),
    tileBottom
  );

  while (endRow < boardBottom && !isLegalBoundary(tiles, endRow)) {
    endRow += 1;
  }

  return {startRow, endRow};
}
